import { render, staticRenderFns } from "./complaint.vue?vue&type=template&id=c4c76a9c&scoped=true&"
import script from "./complaint.vue?vue&type=script&lang=js&"
export * from "./complaint.vue?vue&type=script&lang=js&"
import style0 from "./complaint.vue?vue&type=style&index=0&id=c4c76a9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c76a9c",
  null
  
)

export default component.exports